import './Accueil.css';

const teaserUrl = 'https://www.youtube.com/embed/a5JMnN_Qlzo?autoplay=1&mute=1&loop=1';

function Accueil (){
  return (
    <div className="header">
      <div className="association-section-title">
        <h1>Édition 2022</h1>
      </div>
      <div class="video-wrapper">
        <iframe width="560" height="315" src={teaserUrl} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share; fullscreen" allowfullscreen></iframe>
      </div>

      <div className='texte-certificat-medical'>
        Un <b>certificat médical</b> de non-contre-indication à la pratique du VTT ou de la course à pied (selon le parcours), émis il y a moins de deux ans devra être fournis <b>avant l'événement</b>
      </div>
      <a href="https://raid-des-4-monts.adeorun.com/">
        <button type="button" className="button-billeterie" link="https://raid-des-4-monts.adeorun.com/">
          <h1>BILLETTERIE</h1>
        </button>
      </a>
      <div className='texte-chargement'>
        <b>Le chargement de la billetterie peut être long.</b>
        <br></br>
        <b>Tu es étudiant à l'UTC et tu souhaites faire équipe avec un ingénieur Décathlon ? Renseigne toi sur <a href='https://forms.gle/nX5YzEQ7HQ647Q1r6'>ce formulaire !</a></b>

      </div>
      <div className='texte-caution'>
        Un <b>chèque de caution de 65€</b> sera demandé aux équipes s'aventurant sur le parcours de <b>L'Expédition du Loup Gris</b> en échange du prêt d'une puce <b>sportident</b>. Il est possible de ramener ta puce si elle est compatible : versions S9, S10 ou SIAC (capacité 129 temps)
      </div>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSd0fQx8azZ8ZRUSDavKPrjcqjyABk9A53EMpU6osplzileIsA/viewform">
        <button type="button" className="button-permanencier" link="https://docs.google.com/forms/d/e/1FAIpQLSd0fQx8azZ8ZRUSDavKPrjcqjyABk9A53EMpU6osplzileIsA/viewform">
          <h1>DEVENIR PERMANENCIER</h1>
        </button>
      </a>
    </div>
)
}

export default Accueil
